import type { SVGProps } from 'react';
const SvgError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 38 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="0.5" width="38" height="36" rx="18" fill="#E22828" />
    <path
      d="M18.85 21.975C18.2833 21.975 17.975 21.6583 17.925 21.025L17.2 11.825C17.1667 11.3083 17.3 10.875 17.6 10.525C17.9167 10.175 18.325 10 18.825 10C19.325 10 19.7333 10.175 20.05 10.525C20.3667 10.875 20.5 11.3083 20.45 11.825L19.75 21.025C19.7 21.6583 19.4 21.975 18.85 21.975ZM18.675 27.5C18.1917 27.5 17.8167 27.375 17.55 27.125C17.3 26.8583 17.175 26.4833 17.175 26V25.575C17.175 25.0917 17.3 24.725 17.55 24.475C17.8167 24.2083 18.1917 24.075 18.675 24.075H19C19.4833 24.075 19.85 24.2083 20.1 24.475C20.3667 24.725 20.5 25.0917 20.5 25.575V26C20.5 26.4833 20.3667 26.8583 20.1 27.125C19.85 27.375 19.4833 27.5 19 27.5H18.675Z"
      fill="white"
    />
  </svg>
);
export default SvgError;
